export const SUPERUSERS = ['tomer@madgicx.com', 'sean@madgicx.com', 'admin@madgicx.com'];
